import React from 'react';
import { SearchIcon } from '../../icons';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import {
    setSearchFilters,
    setSearchColumns,
    selectSearchColumns,
    selectSearchFilters,
    setSearchSorting,
} from '../../store/slices/datagridSlice';
import ColumnSelectCard from '../datagridColumnSelectCard';
import FilterSelectCard from './filterSelectCard';
import ClearAllButton from './clearAllButton';
import { colors } from '../../constants';
import './datagridSearchForm.css';

const haveIncompleteFilters = (filters) => {
    let incomplete = false;
    let index = 0;
    if (filters.length > 0) {
        while (!incomplete && index < filters.length) {
            const filter = filters[index];
            const fieldName = filter.fieldName.split('.')[1];

            if (!fieldName) {
                incomplete = true;
            } else if (!filter.operator) {
                incomplete = true;
            } else {
                if (['in', 'not in'].includes(filter.operator)) {
                    if (
                        !filter.value ||
            !Array.isArray(filter.value) ||
            filter.value.length === 0
                    ) {
                        incomplete = true;
                    }
                } else if (
                    ['=', '>', '<', '>=', '<=', '!=', 'contains'].includes(
                        filter.operator
                    )
                ) {
                    if (!filter.value) {
                        incomplete = true;
                    }
                } else if (['<= relative', '>= relative'].includes(filter.operator)) {
                    if (!filter.value || !filter.value?.nUnits || !filter.value?.units) {
                        incomplete = true;
                    }
                }
            }
            index += 1;
        }
    }
    return incomplete;
};

function DataGridSearchForm({ onSearch }) {
    const dispatch = useAppDispatch();

    const searchColumns = useAppSelector(selectSearchColumns);
    const searchFilters = useAppSelector(selectSearchFilters);

    const resetFilters = () => {
        dispatch(setSearchFilters([]));
    };

    const resetColumns = () => {
        dispatch(setSearchColumns([]));
        dispatch(setSearchSorting([]));
    };

    const isSearchDisabled =
    searchColumns.length === 0 || haveIncompleteFilters(searchFilters);

    return (
        <div className="rounded p-3 dataGridSearchCard">
            <div className="row w-100 justify-content-between align-items-center">
                <div className="col-12 col-md-11">
                    <div
                        className="mt-1 shadow-sm rounded py-3 px-4 mb-2"
                        style={{ background: colors.backgroundMedium }}
                    >
                        <div className="d-flex w-100 justify-content-between mb-2">
                            <h2
                                className="fs-6 fw-bold"
                                style={{ color: colors.skyfallMedium }}
                            >
                Filters
                            </h2>
                            <ClearAllButton onClick={resetFilters} />
                        </div>
                        <FilterSelectCard />
                    </div>
                    <div
                        className="mt-1 shadow-sm rounded py-3 px-4"
                        style={{ background: colors.backgroundMedium }}
                    >
                        <div className="d-flex w-100 justify-content-between mb-2">
                            <h2
                                className="fs-6 fw-bold"
                                style={{ color: colors.skyfallMedium }}
                            >
                Columns
                            </h2>
                            <ClearAllButton onClick={resetColumns} />
                        </div>
                        <ColumnSelectCard />
                    </div>
                </div>
                <div className="col-12 col-md-1 text-center pt-2 pt-md-0 ">
                    <button
                        className="btn btn-primary btn-lg"
                        type="button"
                        id="data-grid-search-button"
                        onClick={onSearch}
                        disabled={isSearchDisabled}
                    >
                        <SearchIcon />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default DataGridSearchForm;
